import { render, staticRenderFns } from "./TradeProvenance.vue?vue&type=template&id=b91aba46&scoped=true&"
import script from "./TradeProvenance.vue?vue&type=script&lang=js&"
export * from "./TradeProvenance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b91aba46",
  null
  
)

export default component.exports